"use strict";
var platform_browser_dynamic_1 = require("@angular/platform-browser-dynamic");
var app_module_1 = require("./app/app.module");
platform_browser_dynamic_1.platformBrowserDynamic().bootstrapModule(app_module_1.AppModule);



//////////////////
// WEBPACK FOOTER
// ./src/main.ts
// module id = 0
// module chunks = 0